import * as React from 'react';

export default function preventDefaultCallback(
    ev: React.MouseEvent<unknown> | React.KeyboardEvent<unknown>
): void {
    ev.preventDefault();
}
